<div class="main">
  <div class="container-fluid">
    <div class="d-flex justify-content-start">
      <div class="me-4">
        <button class="btn btn-link text-dark" (click)="GoBack()">
          <i class="fa-solid fa-arrow-left me-3"></i>
          <label class="text-sm fw-semibold">{{
            "DCO.ClaimsClientDocumentation_Back" | translate
            }}</label>
        </button>
      </div>
      <div *ngFor="let dispute of claimOperations">
        <h4 class="mb-0">
          {{ dispute.claimOperationID }}<!--{{"DCO.ClaimsClientDocumentation_DisputeInformation" | translate }}--></h4>
        <p class="text-muted">{{ dispute.commerceName }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-3 col-lg-4 mb-5">
        <div class="d-flex flex-column" *ngFor="let dispute of claimOperations">
          <div class="card px-4 mb-0">
            <div class="card-body">
              <div class="d-flex flex-column text-center mt-4 mb-3">
                <!--<div class="fw-bold text-muted mb-1">
                      {{ "DCO.ClaimsClientDocumentation_Status" | translate }}
                </div>-->
                <ng-container *ngFor="let state of states">
                  <div class="fw-bold fs-6" [ngClass]="{
                    'text-primary': state.stateGroup == 'Gestionados',
                    'text-danger': state.stateGroup == 'Pendientes',
                    'text-success': state.stateGroup == 'Final_favorable',
                    'text-warning': state.stateGroup == 'Final_desfavorable',
                    'text-info':state.stateGroup == 'Expected',
                    }" *ngIf="state.listStateMasterId.includes(dispute.state)">
                    <ng-container *ngIf="state.stateGroup == 'Final_favorable'">
                      <span class="fa-stack fa-3x">
                        <i class="fa-solid fa-circle fa-stack-2x opacity-25"></i>
                        <i class="fa-solid fa-circle fa-stack-1x"></i>
                      </span>
                      <!--<i class="fa-solid fa-circle fa-4x mb-3"></i><br />-->
                      <h5 class="mt-3">{{ "DCO.ClaimsClient_FavorableEnding" | translate }}</h5>
                    </ng-container>
                    <ng-container *ngIf="state.stateGroup == 'Final_desfavorable'">
                      <span class="fa-stack fa-3x">
                        <i class="fa-solid fa-circle fa-stack-2x opacity-25"></i>
                        <i class="fa-solid fa-circle fa-stack-1x"></i>
                      </span>
                      <!--<i class="fa-solid fa-circle fa-4x mb-3"></i><br />-->
                      <h5 class="mt-3">{{ "DCO.ClaimsClient_UnfavorableEnding" | translate }}</h5>
                    </ng-container>
                    <ng-container *ngIf="state.stateGroup == 'Pendientes'">
                      <span class="fa-stack fa-3x">
                        <i class="fa-solid fa-circle fa-stack-2x opacity-25"></i>
                        <i class="fa-solid fa-circle fa-stack-1x"></i>
                      </span>
                      <!--<i class="fa-solid fa-circle fa-4x mb-3"></i><br />-->
                      <h5 class="mt-3">{{ "DCO.ClaimsClient_PendingState" | translate }}</h5>
                    </ng-container>
                    <ng-container *ngIf="state.stateGroup == 'Gestionados'">
                      <span class="fa-stack fa-3x">
                        <i class="fa-solid fa-circle fa-stack-2x opacity-25"></i>
                        <i class="fa-solid fa-circle fa-stack-1x"></i>
                      </span>
                      <!--<i class="fa-solid fa-circle fa-4x mb-3"></i><br />-->
                      <h5 class="mt-3">{{ "DCO.ClaimsClient_ManagedState" | translate }}</h5>
                    </ng-container>
                    <ng-container *ngIf="state.stateGroup == 'Expected'">
                      <span class="fa-stack fa-3x">
                        <i class="fa-solid fa-circle fa-stack-2x opacity-25"></i>
                        <i class="fa-solid fa-circle fa-stack-1x"></i>
                      </span>
                      <!--<i class="fa-solid fa-circle fa-4x mb-3"></i><br />-->
                      <h5 class="mt-3">{{ "DCO.DisputeStatus_Expected" | translate }}</h5>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
              <ng-container *ngFor="let dispute of claimOperations">
                <ng-container *ngFor="let state of states">
                  <div *ngIf="state.listStateMasterId.includes(dispute.state)">
                    <div *ngIf="state.stateGroup == 'Pendientes'" class="d-flex flex-column text-center mb-4">
                      <div class="fw-semibold text-muted">
                        {{
                        "DCO.ClaimsClientDocumentation_RemainingDays"
                        | translate
                        }}
                      </div>
                      <!--<div class="fw-bold fs-6 text-danger">-->
                      <div class="fw-semibold fs-6 text-danger" [ngClass]="GetStatusByDueDate()">
                        {{ dueDateF }}
                      </div>
                      <p class="text-muted text-sm mt-2"><i
                          class="fa-solid fa-triangle-exclamation text-danger"></i>&nbsp;{{
                        "DCO.ClaimsClientDocumentation_RemainingDaysInfo" | translate }}</p>
                      <!-- Si no respondes en el plazo indicado, la disputa se resolverá desfavorablemente -->
                      <!--</div>-->
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="card border-0 shadow-sm mb-0" id="accordion_data">
            <div class="card-body p-0">
              <div class="border-bottom border-2 border-primary px-4 py-3">
                <h5 class="fs-6 fw-semibold text-dark mb-0">
                  {{ "DCO.OperationStatement_DisputeDates" | translate }}
                </h5>
              </div>
              <div class="px-4 pt-4">
                <!-- Número de Expediente -->
                <div class="d-flex flex-column mb-3">
                  <div class="fw-semibold text-muted mb-1">
                    {{ "DCO.OperationStatement_ExpedientNumber" | translate }}
                  </div>
                  <div class="fw-semibold">
                    {{ dispute.claimOperationID }}
                  </div>
                </div>
                <!-- Autorización -->
                <div class="d-flex flex-column mb-3">
                  <div class="fw-semibold text-muted mb-1">
                    {{ "DCO.OperationStatement_Authorization" | translate }}
                  </div>
                  <div class="fw-semibold">
                    {{ dispute.claimOperation_Authorization }}
                  </div>
                </div>
                <!-- Importe -->
                <div class="d-flex flex-column mb-3">
                  <div class="fw-semibold text-muted mb-1">
                    {{ "DCO.OperationStatement_Amount" | translate }}
                  </div>
                  <div class="fw-semibold">
                    {{ dispute.amount | currency:'' : '' : currentFormats?.currency?.digits :
                    currentFormats?.currency?.locale }}
                    {{ getCurrencyCode(dispute.currency) }}
                  </div>
                </div>
                <!-- Fecha de Disputa -->
                <div class="d-flex flex-column mb-3">
                  <div class="fw-semibold text-muted mb-1">
                    {{ "DCO.OperationStatement_DisputeDate" | translate }}
                  </div>
                  <div class="fw-semibold">
                    {{ dispute.doc | date : currentFormats?.date }}
                  </div>
                </div>
                <!-- Motivo -->
                <div class="d-flex flex-column mb-3">
                  <div class="fw-semibold text-muted mb-1">
                    {{ "DCO.OperationStatement_DisputeReason" | translate }}
                  </div>
                  <div class="fw-semibold">
                    {{ dispute.subReasonName | translate }}
                  </div>
                </div>
                <ng-container *ngFor="let disp of claimOperations">
                  <ng-container *ngFor="let state of states">
                    <div *ngIf="state.listStateMasterId.includes(disp.state)">
                      <!-- Gestionados / Pendientes -->
                      <div *ngIf="state.stateGroup == 'Gestionados' || state.stateGroup == 'Pendientes'"
                        class="d-flex flex-column mb-3">
                        <div class="fw-semibold text-muted mb-1">
                          {{ "DCO.OperationStatement_ExpirationDate" | translate }}
                        </div>
                        <div class="fw-semibold">
                          {{ (dispute?.dateLimit && dispute.dateLimit !== 'undefined' && dispute.dateLimit !== '')
                              ? (dispute.dateLimit | date : currentFormats?.date)
                              : '' }}
                        </div>
                      </div>
                      <!-- Finales (Favorable / Desfavorable) -->
                      <div *ngIf="state.stateGroup == 'Final_desfavorable' || state.stateGroup == 'Final_favorable'"
                        class="d-flex flex-column mb-3">
                        <div class="fw-semibold text-muted mb-1">
                          {{ "DCO.OperationStatement_LastStatusDate" | translate }}
                        </div>
                        <div class="fw-semibold">
                          {{ lastUpdate | date : currentFormats?.date }}
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
                <!-- Comentario -->
                <div class="d-flex flex-column mb-4">
                  <div class="fw-semibold text-muted mb-1">
                    {{ "DCO.OperationStatement_Comments" | translate }}
                  </div>
                  <div class="fw-semibold">
                    {{ dispute.comments | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion mt-0" id="manualAccordion">
            <div *ngFor="let item of claimDisputes; let i = index">
              <div class="accordion-item border-0 mb-2" *ngIf="item.type !== 1">
                <div class="card mb-0">
                  <div class="card-body p-0">
                    <h5 class="accordion-header">
                      <button
                        class="accordion-button fs-6 fw-semibold bg-white text-dark shadow-none px-4 border-bottom border-2 border-primary"
                        [class.collapsed]="openIndex !== i" type="button" (click)="toggleAccordion(i)"
                        [attr.aria-expanded]="openIndex === i">
                        {{ "@@CMP.ClaimDispute_HeaderType_" + item.type | translate }}
                      </button>
                    </h5>
                    <div class="accordion-collapse collapse" [class.show]="openIndex === i">

                      <div class="accordion-body px-4 pt-4">
                        <div class="d-flex flex-column mb-3">
                          <div class="fw-semibold text-muted opacity-75 mb-1">
                            {{ "DCO.OperationStatement_ReasonCode" | translate }}
                          </div>
                          <div class="fw-semibold">{{ item.codeReason }}</div>
                        </div>

                        <div class="d-flex flex-column mb-3">
                          <div class="fw-semibold text-muted opacity-75 mb-1">
                            {{ "DCO.OperationStatement_Date" | translate }}
                          </div>
                          <div class="fw-semibold">{{ item.date | date : currentFormats?.date }}</div>
                        </div>

                        <div class="d-flex flex-column mb-3">
                          <div class="fw-semibold text-muted opacity-75 mb-1">
                            {{ "DCO.OperationStatement_Amount" | translate }}
                          </div>
                          <div class="fw-semibold">
                            {{ item.amount | currency:'' : '' : currentFormats?.currency?.digits :
                            currentFormats?.currency?.locale }}
                            {{ getCurrencyCode(dispute.currency) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-9 col-lg-8 mb-5">
        <div class="card">
          <div class="card-body px-4 py-5">
            <ul class="nav nav-tabs nav-line-tabs mb-3 fs-6 mx-1">
              <li class="nav-item">
                <a id="tab_management" class="nav-link fw-semibold"
                  [ngClass]="{ active: this.stateName === 'Pendientes' }" data-bs-toggle="tab" href="#tab_pane_1">{{
                  "DCO.Disputes_DisputeManagement_tab" | translate }}</a>
              </li>
              <li class="nav-item">
                <a id="tab_transaction" class="nav-link fw-semibold" data-bs-toggle="tab" href="#tab_pane_2">{{
                  "DCO.Disputes_Transaction_tab" | translate }}</a>
              </li>
              <li class="nav-item">
                <a id="tab_history" class="nav-link fw-semibold" [ngClass]="{ active: this.stateName !== 'Pendientes' }"
                  data-bs-toggle="tab" href="#tab_pane_3">{{ "DCO.Disputes_History_tab" | translate }}</a>
              </li>
            </ul>
            <div class="tab-content mx-1" id="myTabContent">
              <div class="tab-pane fade"
                [ngClass]="{ active: this.stateName === 'Pendientes', show: this.stateName === 'Pendientes' }"
                id="tab_pane_1" role="tabpanel">
                <div class="card-body px-0">
                  <p><span class="badge bg-secondary p-2 fw-normal text-sm"><i
                        class="fa-solid fa-gear"></i>&nbsp;&nbsp;<em>{{ "DCO.Disputes_Attachments_Info" | translate
                        }}</em></span></p>
                  <h6 class="text-primary py-2">
                    <i class="fa-regular fa-file-lines fa-lg"></i>&nbsp;&nbsp;{{ "DCO.Disputes_Attachments" | translate
                    }}
                  </h6>
                  <DCO-disputes-Management (confirmDisputP)="receiveDynamicFormComfirmation($event)"
                    [transitionsLoaded]="transitionsLoaded" [claimId]="claimId" [claimOperationId]="claimOperationId"
                    [stateTransitionsRes]="stateTransitionsRes" [claimOperations]="claimOperations" class="full-width">
                  </DCO-disputes-Management>
                </div>
              </div>
              <div class="tab-pane fade" id="tab_pane_2" role="tabpanel">
                <div class="card-body px-0">
                  <p><span class="badge bg-secondary p-2 fw-normal text-sm"><i
                        class="fa-regular fa-credit-card"></i>&nbsp;&nbsp;<em>{{ "DCO.Disputes_Transaction_Info" |
                        translate }}</em></span></p>
                  <div class="d-flex flex-wrap" *ngFor="let dispute of claimOperations; index as i">
                    <div class="flex-fill">
                      <h6 class="text-primary py-2">
                        {{ "DCO.ClaimsClientDocumentation_TransactionInformation" | translate }}
                      </h6>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{ "DCO.ClaimsClient_Card" | translate }}
                        </div>
                        <div class="fw-semibold font-monospace fs-6">{{ dispute.card }}</div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{
                          "DCO.ClaimsClientDocumentation_TransactionType"
                          | translate
                          }}
                        </div>
                        <div class="fw-semibold">
                          {{ dispute.transactionType }}
                        </div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{ "DCO.ClaimsClient_Arn" | translate }}
                        </div>
                        <div class="fw-semibold font-monospace fs-6">{{ dispute.arn }}</div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{
                          "DCO.ClaimsClientDocumentation_TransactionDate"
                          | translate
                          }}
                        </div>
                        <div class="fw-semibold">
                          {{
                          dispute.operationDate
                          | date : currentFormats?.date
                          }}   
                          
                          @if (dispute.operationTime?.trim()) {
                            - {{ dispute.operationTime }}
                          }
                        </div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{
                          "DCO.ClaimsClient_AuthorizationNumber" | translate
                          }}
                        </div>
                        <div class="fw-semibold font-monospace fs-6">
                          {{ dispute.claimOperation_Authorization }}
                        </div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{ "DCO.OperationStatement_Amount" | translate }}
                        </div>
                        <div class="fw-semibold fs-5">
                          {{dispute.amount| currency:'' : '' : currentFormats?.currency?.digits :
                          currentFormats?.currency?.locale }}
                          {{ getCurrencyCode(dispute.currency) }}
                        </div>
                      </div>
                    </div>
                    <div class="flex-fill">
                      <h6 class="text-primary py-2">{{ "DCO.ClaimsClient_MerchantInfo" | translate }}</h6>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{ "DCO.ClaimsClient_CommerceNumber" | translate }}
                        </div>
                        <div class="fw-semibold">
                          {{ dispute.commerceNumber }}
                        </div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{
                          "DCO.ClaimsClientDocumentation_BusinessName"
                          | translate
                          }}
                        </div>
                        <div class="fw-semibold">
                          {{ dispute.commerceName }}
                        </div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{
                          "DCO.ClaimsClientDocumentation_Country"
                          | translate
                          }}
                        </div>
                        <div class="fw-semibold">
                          {{ dispute.country }}
                        </div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{
                          "DCO.ClaimsClientDocumentation_ActivitySector"
                          | translate
                          }}
                        </div>
                        <div class="fw-semibold">
                          {{ dispute.businessActivity }}
                        </div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          {{
                          "DCO.ClaimsClientDocumentation_CIF" | translate
                          }}
                        </div>
                        <div class="fw-semibold">{{ dispute.nif }}</div>
                      </div>
                      <div class="d-flex flex-column mb-3" *ngIf="i < 1">
                        <div class="fw-semibold text-muted mb-1">
                          P37
                        </div>
                        <div class="fw-semibold font-monospace fs-6">
                          {{ dispute.operations_P37 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="tab_pane_3" role="tabpanel"
                [ngClass]="{ active: this.stateName !== 'Pendientes', show: this.stateName !== 'Pendientes' }">
                <div class="card-body px-0">
                  <p class="ms-1"><span class="badge bg-secondary p-2 fw-normal text-sm"><i
                        class="fa-solid fa-clock-rotate-left"></i>&nbsp;&nbsp;<em>{{ "DCO.Disputes_Communications_Info"
                        | translate }}</em></span></p>
                  <h6 class="text-primary pt-2 pb-4 ms-1">
                    <i class="fa-regular fa-clock fa-lg"></i>&nbsp;&nbsp;{{
                    "DCO.ClaimsClientDocumentation_CommentsAndCommunications" | translate }}
                  </h6>
                  <div *ngFor="let historic of historicStates | paginate: { itemsPerPage: 10, currentPage: page }">
                    <div *ngIf="historic.isPublicComment" class="d-flex mt-3 ms-3 border-start border-2">
                      <!-- Línea + punto -->
                      <div class="position-absolute ms-13less mt-20less">
                        <i class="fa-solid fa-circle-dot text-primary fa-lg"></i>
                        <!--<span class="timeline-dot"></span>-->
                        <!--<span class="timeline-line"></span>-->
                      </div>
                      <!-- Bloque -->
                      <div class="flex-grow-1 bg-light rounded p-3 ms-3 mb-4 mt-20less">
                        <div class="d-flex justify-content-between mb-2">
                          <h6>
                            {{ historic.stateName | translate }}
                          </h6>
                          <span class="text-muted fs-6">
                            {{ historic.startDate | date:'dd/MM/yyyy HH:mm' }}
                          </span>
                        </div>
                        <div class="text-muted mb-2">
                          <i class="fa-regular fa-user fa-lg me-2"></i>
                          {{ historic.lastUpdateBy}}
                        </div>
                        <div class="mb-2">
                          <i class="fa-regular fa-message fa-lg text-muted me-2"></i>
                          {{ historic.comments }}
                        </div>
                        <div *ngIf="historic.emailId > 0">
                          <a class="text-info pointer" (click)="openEmailModal(historic.emailId)">
                            <i class="fa-solid fa-eye me-2"></i>
                            Ver comunicación
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- paginación -->
                  <div class="has-text-centered">
                    <pagination-controls (pageChange)="page = $event"></pagination-controls>
                  </div>
                </div>
              </div>
            </div>
            <div class="alert alert-primary border-alert-ct d-flex" *ngIf="allowHelp">
              <div class="fa-stack pe-3">
                <i class="fa-regular fa-circle fa-stack-2x"></i>
                <i class="fa-solid fa-info fa-stack-1x"></i>
              </div>
              <div class="ps-3">
                {{ "DCO.ClaimsClient_DisputeDetails_PageDescription" | translate }}&nbsp;<a href="/help"
                  class="fw-semibold">HelpCenter</a>.&nbsp;{{ "DCO.ClaimsClient_DisputeDetails_PageDescription2" |
                translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style type="text/css">
  .modal-content {
    position: absolute;
    width: 750px;
    /* Ancho fijo del modal */
    height: auto;
    /* Ajustar altura automáticamente */
  }

  .ms-13less {
    margin-left: -13px;
  }

  .mt-20less {
    margin-top: -20px;
  }

  /*.timeline-dot {
    width: 14px;
    height: 14px;
    background-color: #0d6efd;
    border-radius: 50%;
    display: block;
    margin-top: 6px;
  }

  .timeline-line {
    width: 2px;
    height: 100%;
    background-color: #dcdcdc;
    position: absolute;
    left: 6px;
    top: 20px;
  }*/
</style>


<div class="modal fade" #changeFileModal id="changeFileModal" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h6 class="modal-title">Email</h6>
        <!--Aqui iría el boton deslizante-->
        <button type="button" class="btn-close" (click)="closeModal();" aria-label="Cancelar"></button>
      </div>
      <div class="modal-body">
        <div class="form">
          <div class="mb-1">
            <div>
              <span style="font-weight: bold;">De: </span>
              <span>{{this.fromAddress}}</span>
            </div>
            <br>
            <div>
              <span style="font-weight: bold;">Para: </span>
              <span>{{this.toWhom}}</span>
            </div>
            <br>
            <div>
              <span style="font-weight: bold;">Asunto: </span>
              <span>{{this.subject}}</span>
            </div>
            <br>
            <div>
              <span style="font-weight: bold;">Adjunto: </span>
              <span>archivo.txt</span>
            </div>
            <br>
          </div>
          <hr>
          <div style="border: 1px;">
            <div style="width: 100%;height: auto;" [innerHTML]="this.emailText"></div>
          </div>
          <div class="mb-0">
            <div class="modal-footer d-flex justify-content-center">
              <button type="button" class="btn btn-outline-danger"
                (click)="closeModal();">{{"DCO.MassiveInformation_Cancel" | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
